<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content" v-menu-permission="'list'">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body" style="background-color: #333333">
              <!--              <el-button type="primary" icon="el-icon-edit" circle @click="refreshDate"></el-button>-->

              <!-- 左上角 产量曲线 -->
              <div class="prod-data-box">
                <!-- 这里用DataV的边框初始化会超出，DV可能是后绘制的 -->
                <echart-prod-data></echart-prod-data>
              </div>

              <div
                id="monitor-tree-chart"
                style="width: auto; height: 1500px"
              ></div>
              <el-dialog
                :title="lineChartTitle"
                :visible.sync="dialogFormVisible"
              >
                <eoc-record-line-chart
                  ref="recordChart"
                  :node-id="nodeId"
                  :autoRefresh="dialogFormVisible"
                ></eoc-record-line-chart>
              </el-dialog>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--右键弹出菜单-->
    <div id="rightMenu" class="rMenu" style="display: none">
      <li @click="showDeviceMaintenanceRecord">设备维修记录</li>
      <li @click="showDeviceFaultsRecord">设备故障记录</li>
    </div>

    <el-dialog :title="lineChartTitle" :visible.sync="maintenanceDialogVisible">
      <tabs>
        <div v-for="item in devices" :key="item.id">
          <pane v-bind:label="item.name" v-bing:name="item.name">
            <!-- <table width="100%" border="1" cellspacing="0" cellpadding="0"> -->
            <table width="100%" class="table" cellspacing="0" cellpadding="0">
              <thead align="center">
                <tr>
                  <th>事件性质</th>
                  <th>实际开始时间</th>
                  <th>执行人</th>
                  <th>工作内容</th>
                  <th>安全内容</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="recordItem in item.deviceMaintenanceRecord"
                  :key="recordItem.id"
                >
                  <td v-text="recordItem.repairEventLevelCode"></td>
                  <td v-text="recordItem.actualStartTime"></td>
                  <td v-text="recordItem.executor"></td>
                  <td v-text="recordItem.jobContent"></td>
                  <td v-text="recordItem.safeContent"></td>
                </tr>
              </tbody>
            </table>
          </pane>
        </div>
      </tabs>
    </el-dialog>

    <el-dialog :title="lineChartTitle" :visible.sync="faultsDialogVisible">
      <tabs>
        <div v-for="item in devices2" :key="item.id">
          <pane v-bind:label="item.name" v-bing:name="item.name">
            <div>
              <button @click="previousMonth">上个月</button>
              <button @click="nextMonth">下个月</button>
            </div>
            <echart-faults-record
              :options="showDeviceFaultsEchart(item)"
            ></echart-faults-record>
          </pane>
        </div>
      </tabs>
    </el-dialog>
  </div>
</template>
<script>
// Author YuJiaBei
// Date 2021-07-02 15:49:35

import emCommonListMixin from "@/mixin/em/common/list";
import emApiMixin from "@/mixin/em/common/api";
import eocRecordLineChart from "@/views/em/opcClient/EmOpcComputedRecordLineChart";
import * as echarts from "echarts";

import echartProdData from "@/views/em/statusCollection/echarts/echartProdData";
import echartFaultsRecord from "@/views/em/statusCollection/echarts/echartFaultsRecord";

import tabs from "@/components/em/EmTabs/EmTabs";
import pane from "@/components/em/EmTabs/EmTabPane";
// import ECharts from 'vue-echarts';

//import theme from 'echarts/theme/dark-bold';

export default {
  name: "emSicEmrecREocMonitor",
  mixins: [emCommonListMixin, emApiMixin],
  components: {
    eocRecordLineChart,
    echartProdData,
    tabs,
    pane,
    echartFaultsRecord,
  },
  data() {
    return {
      data: [],
      operation: {},
      myChart: {},
      dialogFormVisible: false,
      maintenanceDialogVisible: false,
      faultsDialogVisible: false,
      nodeId: "",
      nodeName: "",
      collapsedNodeKeySet: new Set(),
      timer: null,
      lineChartTitle: "",
      timerInterval: 6000,
      devices: [],
      devices2: [],
      option: {},
      option2: {},
      chartDate: new Date(),
    };
  },
  computed: {
    modelName() {
      return "emSicEmrecREocMonitor";
    },
  },
  methods: {
    refreshDate() {
      this.$_emApiMixin_get(
        this.$_emApiMixin_entityBaseApi("emSicEafmREocEmrec") + "/treeMonitor"
      ).then((res) => {
        this.data = res;
        //遍历数据，设置展开状态, 因为只会渲染data[0]，所以就只传0
        this.fillCollapsed(this.data[0]);
        //重新渲染myChart
        this.myChart.setOption({
          series: [
            {
              data: this.data,
            },
          ],
        });
      });
    },
    fillCollapsed(data) {
      // console.log("fillCollapsed:",data)
      if (data && data.nodeKey && this.collapsedNodeKeySet.has(data.nodeKey)) {
        // console.log("fillCollapsed: set true")
        data.collapsed = true;
      }
      if (data && data.children) {
        // console.log("fillCollapsed: has children")
        data.children.forEach((f) => this.fillCollapsed(f));
      }
    },

    showDeviceMaintenanceRecord() {
      var url =
        process.env.VUE_APP_EM_ARCHIVE_URL +
        "/emArchBasicData/findDMR/" +
        rightNodeId;

      this.$store.dispatch("api/get", { url }).then((data) => {
        this.devices = data;
      });
      console.log(rightNodeId);
      this.lineChartTitle =
        "工厂模型【" + rightNodeName + "】关联的设备的维修记录";
      this.maintenanceDialogVisible = true;
      hideRightMenu();
    },

    showDeviceFaultsRecord() {
      var timestamp = this.chartDate.getTime();
      var url =
        process.env.VUE_APP_EM_ARCHIVE_URL +
        "/emArchBasicData/findDFRChart/" +
        rightNodeId +
        "/" +
        timestamp;

      this.$store.dispatch("api/get", { url }).then((data) => {
        this.devices2 = data;
      });
      this.lineChartTitle =
        "工厂模型【" + rightNodeName + "】关联的设备的故障记录";
      this.faultsDialogVisible = true;
      hideRightMenu();
    },

    previousMonth() {
      this.chartDate.setMonth(this.chartDate.getMonth() - 1);
      var timestamp = this.chartDate.getTime();
      var url =
        process.env.VUE_APP_EM_ARCHIVE_URL +
        "/emArchBasicData/findDFRChart/" +
        rightNodeId +
        "/" +
        timestamp;

      this.$store.dispatch("api/get", { url }).then((data) => {
        this.devices2 = data;
      });
      this.lineChartTitle =
        "工厂模型【" + rightNodeName + "】关联的设备的故障记录";
      this.faultsDialogVisible = true;
    },

    nextMonth() {
      this.chartDate.setMonth(this.chartDate.getMonth() + 1);
      var timestamp = this.chartDate.getTime();
      var url =
        process.env.VUE_APP_EM_ARCHIVE_URL +
        "/emArchBasicData/findDFRChart/" +
        rightNodeId +
        "/" +
        timestamp;

      this.$store.dispatch("api/get", { url }).then((data) => {
        this.devices2 = data;
      });
      this.faultsDialogVisible = true;
    },

    showDeviceFaultsEchart(item) {
      const data = item.deviceFaultsRecordChart.data;
      let newFaults = item.deviceFaultsRecordChart.data[0];
      var now = new Date(newFaults.value[0]);
      var month = now.getMonth() + 1;
      var year = now.getFullYear();
      var nextMonthFirstDay = new Date(
        [year, month + 1, 1].join("-")
      ).getTime();
      var oneDay = 1000 * 24 * 60 * 60;
      var monthLast = new Date(nextMonthFirstDay - oneDay).getDate();
      let firstDay = [year, month, 1].join("-");
      let lastDay = [year, month, monthLast].join("-");

      var result = {
        title: {
          // text: "设备【" + item.name + "】的故障记录",
        },
        tooltip: {
          formatter: function () {
            console.log(arguments);
            let info = arguments[0].data.info;
            return (
              "故障开始时间:" +
              info.acctStartDate +
              "<br/>" +
              "故障等级:" +
              info.acctIdAcl +
              "<br/>" +
              "故障分类:" +
              info.acctIdAct +
              "<br/>" +
              "故障编码:" +
              info.acctCode +
              "<br/>" +
              "故障结束时间:" +
              info.acctEndDate +
              "<br/>"
            );
          },
          textStyle: {
            fontSize: 10,
          },
        },
        legend: {
          // data: ["故障次数"],
        },
        xAxis: {
          name: "日期",
          type: "time",
          min: firstDay,
          max: lastDay,
          minInterval: 1,
        },
        yAxis: {
          name: "次数",
          type: "value",
          min: 0,
          max: 5,
          minInterval: 1,
          axisLabel: {
            formatter: "{value}",
          },
        },
        series: [
          {
            symbolSize: 10,
            name: "故障信息",
            type: "scatter",
            data,
          },
        ],
      };
      return result;
    },
  },

  mounted() {
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.getElementById("monitor-tree-chart")); // -= ,'dark-bold',{renderer: 'svg'} =- //svg渲染
    this.myChart.showLoading();

    this.myChart = echarts.init(document.getElementById("monitor-tree-chart"));

    //去除默认的鼠标事件
    document.oncontextmenu = function () {
      return false;
    };

    //新加上鼠标右击事件
    this.myChart.on("contextmenu", function (params) {
      if (params.data.nodeType !== "eafm") {
        return;
      }
      rightNodeName = params.data.name;
      rightNodeId = params.data.id;
      this.dialogFormVisible = false;
      showRightMenu(params.event.offsetX, params.event.offsetY);
      // openMenu(params.event.offsetX, params.event.offsetY);
    });

    //START: echart-tree  设备监控
    this.$_emApiMixin_get(
      this.$_emApiMixin_entityBaseApi("emSicEafmREocEmrec") + "/treeMonitor"
    ).then((res) => {
      console.log(res);
      this.data = res;
      this.myChart.hideLoading();
      // 绘制图表
      this.myChart.setOption({
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
        },
        series: [
          {
            type: "tree",

            data: this.data,

            top: "4%",
            left: "10%",
            bottom: "4%",
            right: "7%",

            symbolSize: 9, //标记的大小，就是那个小圆圈，默认7

            //orient: 'BT',   //树型方向

            label: {
              //每个节点所对应的标签的样式
              normal: {
                //rotate: -90,//标签旋转。从 -90 度到 90 度。正值是逆时针。
                position: "left", //标签的位置
                verticalAlign: "middle", //文字垂直对齐方式，默认自动。可选：top，middle，bottom
                align: "right", //文字水平对齐方式，默认自动。可选：top，center，bottom
                fontSize: 12, //标签文字大小
                color: "#ffffff", //文字颜色
              },
            },
            // itemStyle: {
            // color: function (params) {
            //   if (params.status === "1") {
            //     return "#FE8463";
            //   } else if (params.status === "2") {
            //     return "#27727B";
            //   }
            //   return "#9BCA63";
            // }
            //   color:"#9BCA63"
            // },
            itemStyle: {
              normal: {
                color: "#33A4D8", //节点颜色    515b67  009933
                //borderColor: "#0098ff",
                lineStyle: {
                  color: "#33A4D8", //树枝线条颜色
                },
              },
            },

            leaves: {
              //叶子节点的特殊配置，如上面的树图示例中，叶子节点和非叶子节点的标签位置不同
              label: {
                position: "right",
                verticalAlign: "middle",
                align: "left",
                //rotate: 90,   //垂直90度
                //color: "#ff0000",   //叶子节点文字颜色
              },
              //单独设置叶子节点的颜色
              itemStyle: {
                color: "#009933", //节点颜色  009933
              },
            },

            emphasis: {
              focus: "descendant",
            },

            // expandAndCollapse: true,   //默认：true；子树折叠和展开的交互，默认打开
            initialTreeDepth: -1, //默认初始化节点数量
            animationDuration: 550, //动画时间
            animationDurationUpdate: 750, //动画更新时间
          },
        ],
      });
    });
    //绑定单击事件
    this.myChart.on("click", (params) => {
      // 隐藏右键菜单
      hideRightMenu();
      //如果是工厂模型，就记录折叠状态
      if (params.data.nodeType === "eafm") {
        if (this.collapsedNodeKeySet.has(params.data.nodeKey)) {
          this.collapsedNodeKeySet.delete(params.data.nodeKey);
        } else {
          this.collapsedNodeKeySet.add(params.data.nodeKey);
        }
      }
      //如果是计算属性，就弹出实时曲线
      else if (params.data.nodeType === "emrec") {
        this.lineChartTitle = params.data.nodeName;
        this.nodeId = params.data.eocNodeId;  //东滩： 后端 EmrecMonitorNodeDataVoAdapter 里适配绑定的计算属性ID，所以这里的eocNodeId已经不是nodeId了
        this.dialogFormVisible = true;
      }
    });
    //END: echart-tree  设备监控

    //设置定时器
    this.timer = setInterval(this.refreshDate, this.timerInterval);
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },
};

function showRightMenu(x, y) {
  $("#rightMenu").css({
    display: "block",
    left: x + 5,
    top: y + 5,
  });
}

function hideRightMenu() {
  $("#rightMenu").css({
    display: "none",
  });
}

var rightNodeId;
var rightNodeName;
</script>

<style scoped>
.prod-data-box {
  position: absolute;
  z-index: 1;
  width: 30%;
  height: 20rem;
  margin: 1rem 1rem;
  border: #33a4d8 2px solid;
  border-radius: 8px;
  background: url("../../../assets/images/emKpi/line.png")
    rgba(255, 255, 255, 0.08);
  /*background-image: -webkit-linear-gradient(top, rgba(255, 255, 255, 0.1) 0%, rgba(0, 0, 0, 0.1) 40%, rgba(0, 0, 0, 0.2) 98%, #FFFFFF 100%);*/
  /*background-color: #92D050;*/
}
table {
  border-collapse: collapse;
  margin: 0 auto;
  text-align: center;
}
table td,
table th {
  border: 1px solid #cad9ea;
  color: #666;
  height: 30px;
}
table thead th {
  background-color: #cce8eb;
  width: 100px;
}
table tr:nth-child(odd) {
  background: #fff;
}
table tr:nth-child(even) {
  background: #f5fafa;
}
</style>